import * as React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Chip, TableCell, TableRow } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export function RowBadges(props) {
  const {
    row,
    setShowModalEdit,
    setSelectedBadge,
    setShowModalDetail,
    setShowModalDelete,
  } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.nameBadge ?? "---"}
        </TableCell>
        <TableCell align="center">{row?.description ?? "---"}</TableCell>
        <TableCell align="center">{row?.membershipReq ?? "---"}</TableCell>
        <TableCell align="center">
          <Chip
            label={row?.isActive ? "Activa" : "Inactiva "}
            style={{
              backgroundColor: row?.isActive
                ? "rgb(5,193,104,20%)"
                : "rgba(255,90,101,20%)",
              color: row?.isActive ? "#14CA74" : "#FF5A65",
            }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<InfoIcon />}
                  onClick={() => {
                    setSelectedBadge(row);
                    setShowModalDetail(true);
                  }}
                >
                  Detalles
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<EditIcon />}
                  onClick={() => {
                    setSelectedBadge(row);
                    setShowModalEdit(true);
                  }}
                >
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="white"
                  startIcon={<DeleteForeverIcon />}
                  onClick={() => {
                    setSelectedBadge(row);
                    setShowModalDelete(true);
                  }}
                >
                  Eliminar
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
